/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import './index.css';
// Import the BorrowerLeadFormModal component
import BorrowerLeadFormModal from "../../commoncomponents/BorrowerLeadFormModal/borrowerleadformmodal";

const ApplyForLoanWithSWMC = ({ data, leadSource }) => {
  // State for modal control
  const [showContactModal, setShowContactModal] = useState(false);
  const [formHeading, setFormHeading] = useState("");
  const [loanPurpKeyword, setLoanPurpKeyword] = useState("");
  const [noteRate, setNoteRate] = useState("");
  const [offerTerm, setOfferTerm] = useState("");

  if (!data) return null;
  
  const { title, subtitle, description, buttonText } = data;
  
  // Handle modal close
  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };
  
  // Handle apply button click to open modal
  const handleApplyButtonClick = () => {
    setFormHeading(buttonText || "Apply Now");
    setLoanPurpKeyword("");
    setNoteRate("");
    setOfferTerm("");
    setShowContactModal(true);
  };

  return (
    <section className="apply-loan-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={10}>
            <div className="apply-loan-container">
              <h2 className="apply-loan-title">
                {title ? parse(title) : 'Apply for a Loan with Sun West!'}
              </h2>
              {subtitle && (
                <p className="apply-loan-subtitle">
                  {parse(subtitle)}
                </p>
              )}
              {description && (
                <p className="apply-loan-description">
                  {parse(description)}
                </p>
              )}
              <button
                onClick={handleApplyButtonClick}
                className="apply-loan-button"
              >
                {buttonText ?
                  parse(buttonText.replace(/<span>.*?<\/span>/g, '')) :
                  'Apply Now'}
                <img src='https://resources.swmc.com/loan-programs/common/right-arrow.webp' className="arrow-icon apply-arrow-icon" alt='arrow'/>
              </button>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Add the BorrowerLeadFormModal component */}
      <BorrowerLeadFormModal
        formHeading={formHeading}
        loanPurpKeyword={loanPurpKeyword}
        noteRate={noteRate}
        offerTerm={offerTerm}
        showLeadFormModal={showContactModal}
        onHide={handleCloseContactModal}
        leadSource={leadSource}
      />
    </section>
  );
};

export default ApplyForLoanWithSWMC;